import React, { PropsWithChildren } from 'react';
import { Heading, HeadingHierarchy } from '../../Heading/Heading';
import { useWidgetHeaderId } from '../Widget.utils';

type WidgetHeadingProps = PropsWithChildren<{
  hierarchy?: HeadingHierarchy;
}>;

export function WidgetHeading({ hierarchy = 2, children }: WidgetHeadingProps) {
  const widgetHeaderId = useWidgetHeaderId();

  return (
    <Heading hierarchy={hierarchy} className="widget-header__title" id={widgetHeaderId}>
      {children}
    </Heading>
  );
}
